// extracted by mini-css-extract-plugin
module.exports = {"bg":"_5eg2o","inlineContent":"_1dxg9","pageWrapper":"b1rUe"};